<template>
  <Modal v-model="model" sticky reset-drag-position title="客户信息" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="service_customer_Info" width="1200">
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeightPop" class="element_table" stripe ref="selection"  @cell-click="openIVRCall" :cell-class-name="returnClassName">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title"></el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "IVRCountPop",
    mixins:[publicFunClass],
    props:{
      showIVRCount:Boolean,
      ivrTotal:Object,
      starEndTime:Array
    },
    data(){
      return {
        model:false,
        tableHeightPop:600,
        contentList: [],
        spinShow: true,
        selection:'',
        fieldList: [{key:'phone','title':'来电号码'},{key:'time','title':'按键时间'}],
        total: 0,
        pageSize: 20,
        currentPage: 1,
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        speedChangePage: 1
      }
    },
    methods:{
      cancel:function(){
        this.$emit("closeIVRCount",false);
      },
      openIVRCall:function(row,column){
        if(column.property){
          let phone=row["phone"];
          if(column.property=='phone' || column.property=='phoneHide'){
            this.$emit("closeIVRCount",phone);
            return false;
          }
        }
      },
      initSearch:function () {
        let param={
          date:this.starEndTime.length==0?"":this.starEndTime.toString(),
          ivrKey:this.ivrTotal.ivrKey,
          ivrname:this.ivrTotal.ivrname,
          smsButtonDesc:this.ivrTotal.smsButtonDesc,
          ivrLevel:this.ivrTotal.ivrLevel
        };
        let that=this;
        this.$http.post("callIvrButton/doSelectOne.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          let phoneIsHide= that.configInfo.phoneIsHide;
          if(phoneIsHide=='1'){
            that.fieldList=[{key:'phoneHide','title':'来电号码'},{key:'time','title':'按键时间'}];
            for(let i=0;i< that.contentList.length;i++){
              let phone=that.contentList[i].phone;
              that.contentList[i].phoneHide=phone;
              if(phone.length>=11){
                that.contentList[i].phoneHide=phone.substring(0,phone.length-8)+"****"+phone.substring(phone.length-4,phone.length)
              }
            }
          }
          that.total=res.data.obj.list.totalSize;
        })
      }
    },
    watch:{
      showIVRCount:function () {
        this.model=this.showIVRCount;
        if(this.showIVRCount){
          this.initSearch();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/CallStatistics/IVRCountPop.vue